import { FormControlLabel, Checkbox } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const UsageHistoryForm = ({
    usageHistory,
    setUsageHistory,
}: {
    usageHistory: boolean;
    setUsageHistory: (usageHistory: boolean) => void;
}): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <FormControlLabel
            label={t('support.clientConfiguration.usageHistory')}
            control={
                <Checkbox
                    checked={usageHistory}
                    onChange={() => {
                        setUsageHistory(!usageHistory);
                    }}
                />
            }
        />
    );
};

export default React.memo(UsageHistoryForm);
